import _toConsumableArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
/* eslint-disable import/prefer-default-export */

import SandboxDependencies from './Dependencies';
import flattenRelativeImports from './FlattenRelativeImports';
function getFileExtension(codeVariant) {
  if (codeVariant === 'TS') {
    return 'tsx';
  }
  if (codeVariant === 'JS') {
    return 'jsx';
  }
  throw new Error("Unsupported codeVariant: ".concat(codeVariant));
}
export function createMuiChat(demoData) {
  var title = demoData.title,
    description = demoData.githubLocation;
  var ext = getFileExtension(demoData.codeVariant);

  // Get dependencies like StackBlitz
  var _SandboxDependencies = SandboxDependencies(demoData, {
      commitRef: process.env.PULL_REQUEST_ID ? process.env.COMMIT_REF : undefined
    }),
    dependencies = _SandboxDependencies.dependencies;
  return {
    title: title,
    description: description,
    dependencies: dependencies,
    openSandbox: function () {
      var _openSandbox = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var baseUrl, productToPackage, primaryPackage, files, response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              baseUrl = process.env.MUI_CHAT_API_BASE_URL;
              if (baseUrl) {
                _context.next = 3;
                break;
              }
              throw new Error('Could not find the MUI Chat URL, please open a new issue on https://github.com/mui/material-ui/issues/new');
            case 3:
              // Determine primary package from productId or fallback to dependencies
              productToPackage = {
                'material-ui': '@mui/material',
                'joy-ui': '@mui/joy',
                'x-data-grid': '@mui/x-data-grid',
                'x-date-pickers': '@mui/x-date-pickers',
                'x-tree-view': '@mui/x-tree-view',
                'x-charts': '@mui/x-charts'
              };
              primaryPackage = '@mui/material'; // default fallback
              if (demoData.productId && productToPackage[demoData.productId]) {
                primaryPackage = productToPackage[demoData.productId];
              }

              // Process files from demoData similar to StackBlitz
              files = [{
                path: "".concat(demoData.title, ".").concat(ext),
                content: flattenRelativeImports(demoData.raw),
                isEntry: true
              }].concat(_toConsumableArray((demoData.relativeModules || []).map(function (module) {
                return {
                  path: module.module.replace(/^.*[\\/]/g, ''),
                  content: flattenRelativeImports(module.raw)
                };
              })));
              _context.prev = 7;
              _context.next = 10;
              return fetch("".concat(baseUrl, "/v1/public/chat/open"), {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  name: demoData.title,
                  description: document.title,
                  files: files,
                  type: 'mui-docs',
                  "package": {
                    name: primaryPackage,
                    version: dependencies[primaryPackage] || 'latest'
                  }
                })
              });
            case 10:
              response = _context.sent;
              if (response.ok) {
                _context.next = 13;
                break;
              }
              throw new Error('Failed to open in MUI Chat');
            case 13:
              _context.next = 15;
              return response.json();
            case 15:
              data = _context.sent;
              window.open(data.nextUrl, '_blank');
              _context.next = 23;
              break;
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](7);
              console.error('Error opening MUI Chat:', _context.t0);
              throw _context.t0;
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[7, 19]]);
      }));
      function openSandbox() {
        return _openSandbox.apply(this, arguments);
      }
      return openSandbox;
    }()
  };
}